<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/31MO0S/tc-custom/9781613127568.jpg?1728259255504" alt="This image is the cover for the book Cuckoo Song"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cuckoo Song
      </h1>
      <p class="bookDescription body article font2">
        <b>“Full of rich language that is reminiscent of an old fairy tale. . . . [a] spine-chilling, creative work [and] a well-wrought fantasy.” —<i>School Library Journal</i> (starred review)</b><br/>  <br/> Following a mysterious incident that leaves her feverish and sopping wet, Triss awakens to a world that’s eerily off-kilter. Her memories are muddled, her sister despises her, and when she brushes her hair, out come crumbled fragments of leaves. Is she going mad? Or has she endured a nightmarish chain of events? Is this related to the illnesses she’s had since her brother died in the Great War? And why is she so hungry? In her search for the truth, Triss ventures from the shelter of her parents’ protective wings into the city’s underbelly. There she encounters strange creatures whose grand schemes could forever alter the fates of her family, in an unnerving tale of one girl’s struggle to confront her darkest fears.<br/>  <br/> “Few authors can evoke a twinned sense of terror and wonder better . . . Vivid, frightening, and inventive, with narrative twists and turns. . . . A piercing, chilling page-turner.” —<i>Booklist</i> (starred review)<br/>  <br/> “Nuanced and intense.” —<i>Kirkus Reviews</i> (starred review)<br/>  <br/> “Quiet but elegant prose moves the story seamlessly from an effectively creepy horror tale to a powerful, emotionally resonant story of regret and forgiveness.” —<i>Bulletin of the Center for Children’s Books</i> (starred review)<br/>  <br/> “Gorgeously written and disconcerting . . . Hardinge delves deeply into the darker side of family life.” —<i>Publishers Weekly</i> (starred review)<br/>  <br/> “<i>Cuckoo Song</i> transcends its teen-reader designation. The psychological and historical nuances . . . will mesmerize older readers as well.” —<i>BookPage</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frances Hardinge
      </h2>
      
      <p class="authorDescription body article">Frances Hardinge is the winner of the Costa Book of the Year and Costa Children’s Book Awards for The Lie Tree. She is also the author of The Lost Conspiracy (five starred reviews; Los Angeles Times Book Prize finalist), Fly by Night (shortlisted for the Guardian Children’s Fiction Prize), Well Witched (School Library Journal Best Book of 2008), and Fly Trap (shortlisted for the Guardian prize, longlisted for the CILIP Carnegie Medal). She lives in England. www.franceshardinge.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26811151